import { S3ResourceContentType } from "./S3.dto";

export function convertFileTypeToS3ResourceContentType(fileType: string) {
  switch (fileType) {
    case "application/pdf":
      return S3ResourceContentType.Pdf;
    case "image/bmp":
    case "image/jpeg":
    case "image/png":
    case "image/svg+xml":
    case "image/tiff":
      return S3ResourceContentType.Image;
    case "text/plain":
    case "text/rtf":
    case "application/xml":
    case "text/xml":
      return S3ResourceContentType.Text;
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return S3ResourceContentType.Word;
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return S3ResourceContentType.Excel;
    case "application/xhtml+xml":
      return S3ResourceContentType.Html;
    case "application/dicom":
      return S3ResourceContentType.Dicom;
    case "application/vnd.ms-powerpoint":
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return S3ResourceContentType.Ppt;
    case "application/zip":
      return S3ResourceContentType.Zip;
    default:
      return S3ResourceContentType.Text;
  }
}
